import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import THEME from '../../theme';
import DefaultSummary from './DefaultSummary';
import Badge from '../Badge';
import { selectTemplatesMap } from '@debbie/cortex/dist/templates/selectors';
const Tags = styled.span `
  & > div {
    background: ${THEME.SUCCESS};
    display: inline-block;
    border-radius: 3px;
    color: ${THEME.COLOR_SECONDARY};
    padding: 0.2em 0.6em;
    font-size: 0.7em;
    font-weight: bold;
    margin-right: 5px;

    &.failed {
      background: ${THEME.DANGEROUS};
    }
  }
`;
const AutoCall = (props) => {
    var _a;
    const interaction = props.interaction;
    const autoCall = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    const template = useSelector((s) => {
        const templatesMap = selectTemplatesMap(s);
        return ((interaction.templateId && templatesMap[interaction.templateId]) || null);
    });
    return (React.createElement(DefaultSummary, Object.assign({}, props),
        template && (React.createElement(React.Fragment, null, !!((_a = template.tags) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement("p", { style: { marginTop: 0 } }, template.tags.map(({ tag }) => (React.createElement(Badge, { style: { marginRight: 5 }, theme: THEME.COLOR_ACCENT }, lang.templateTags[tag]))))))),
        React.createElement("div", null,
            lang.autoCall.called,
            " +",
            autoCall.toCountryCode,
            ' ',
            autoCall.toPhoneNumber,
            " ",
            lang.autoCall.from,
            " +",
            autoCall.fromCountryCode,
            " ",
            autoCall.fromPhoneNumber,
            ":"),
        props.interaction.events && !!props.interaction.events.length ? (React.createElement(Tags, { style: {
                marginTop: `${THEME.GRID_SPACING}px`,
                wordBreak: 'break-word',
            } }, props.interaction.events
            // @ts-ignore
            .filter((e) => !['human', 'record'].includes(e.status))
            .map((event) => {
            const eventLabel = lang.autoCallEvents[
            // @ts-ignore
            event.status] ||
                // @ts-ignore
                event.status ||
                // @ts-ignore
                (event.dtmf && event.dtmf && event.dtmf.digits
                    ? // @ts-ignore
                        `${event.dtmf.digits}#`
                    : '');
            if (!eventLabel)
                return null;
            return (React.createElement("div", { key: event.id, "data-tooltip-content": moment(event.createdAt).format(THEME.DATE_FORMAT_LONG), "data-tooltip-id": "tooltip-default" }, eventLabel));
        }))) : null,
        React.createElement("p", null, autoCall.transcript)));
};
export default AutoCall;
//# sourceMappingURL=AutoCall.js.map